// Sagas are what field all the async requests in redux.  They make it easier
// to deal with this data, and also make it easier to test async calls from the ui
// You can read more about them here: https://github.com/redux-saga/redux-saga

import { put, call, takeEvery } from "redux-saga/effects";
import { getLoanDetails } from "../utils/requests";
import { errorMessages } from "../utils/content";

import {
  mortgagePopup,
  studentLoanPopup,
  doublePaymentConfirmationPopup,
  scheduledAchPaymentConfirmationPopup
} from "../utils/popupModals";

export function* loadLoan({ loanDetails }) {
  try {
    yield put({
      type: "HIDE_NOTIFICATION"
    });
    yield put({
      type: "SHOW_MODAL",
      modalType: "loading",
      message: "Loading..."
    });
    const data = yield call(getLoanDetails, loanDetails);
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
    if (data.ExternalMinorAccountTypeCodeRedirectionType === "StudentLoan") {
      // Show the student loan popup modal
      yield put({ type: "SHOW_MODAL", ...studentLoanPopup });
    }
    if (data.ExternalMinorAccountTypeCodeRedirectionType === "Mortgage") {
      // Show the mortgage popup modal
      yield put({ type: "SHOW_MODAL", ...mortgagePopup });
    }
    if (data.PaymentAlreadySubmittedToday) {
      yield put({ type: "PAUSE_APP" });
      // Show modal if user has already made a payment on this loan today
      yield put({ type: "SHOW_MODAL", ...doublePaymentConfirmationPopup });
    }
    if (data.AchPaymentScheduled) {
      yield put({ type: "PAUSE_APP" });
      // Show modal if there is a scheduled ach payment
      yield put({ type: "SHOW_MODAL", ...scheduledAchPaymentConfirmationPopup });
    }
    if (data.InformationGivenDoesNotMatch) {
      yield put({
        type: "SHOW_NOTIFICATION",
        notificationType: "error",
        message: errorMessages.loanNotFound
      });
    } else {
      yield put({
        type: "LOAN_LOADED",
        payload: data
      });
    }
  } catch (error) {
    // Request didn't work
    yield put({
      type: "SHOW_NOTIFICATION",
      notificationType: "error",
      message: errorMessages.requestFailed});
    yield put({
      type: "HIDE_MODAL",
      modalType: "loading"
    });
  }
}

// Watch for loan request and execute action to set loan state
export function* watchLoanRequest() {
  yield takeEvery("GET_LOAN", loadLoan);
}



// WEBPACK FOOTER //
// ./src/sagas/loadLoanDetails.sagas.js